import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ffce1590")

_pushScopeId("data-v-ffce1590")
const _hoisted_1 = { class: "footer-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, "Copyright © 2021 深圳市汉德网络科技有限公司 版权所有 粤ICP备17055485号"))
})